import Vue from 'vue'
import Router from 'vue-router'

import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import common_helper from '../common_helper'

// Containers, Icons & Pages
import Full from '@/containers/Full'
import Charts from '@/views/Charts'
import Widgets from '@/views/Widgets'
import FontAwesome from '@/views/icons/FontAwesome'
import SimpleLineIcons from '@/views/icons/SimpleLineIcons'
import inwardlist from '@/views/components/inwardlist'
import CryptoJS from 'crypto-js';
import invoiceErrorReport from '@/views/components/invoiceErrorReport'
import falseblockedrackstock from '@/views/components/falseblockedrackstock'
import boxtype from '@/views/components/boxtype'
import shippingDetails from '@/views/components/shippingDetails'
import stocktransfer from '@/views/components/stocktransfer'
import stnboxtype from '@/views/components/stnboxtype'
import grclist from '@/views/components/GRC/grclist'
import sourceSTNreport from '@/views/components/sourceSTNreport'
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'
import Login from '@/views/components/login'
import invalidurl from '@/views/components/invalidurl'
import invalidurll from '@/views/components/invalidurll'
import Register from '@/views/pages/Register'
import Buttons from '@/views/components/Buttons'
import SocialButtons from '@/views/components/SocialButtons'
import Cards from '@/views/components/Cards'
import Forms from '@/views/components/Forms'
import Modals from '@/views/components/Modals'
import Switches from '@/views/components/Switches'
import Tables from '@/views/components/Tables'
import test from '@/views/test'

// Views - Components
import dashboard from '@/views/components/dashboard'
import Merchantdashboard from '@/views/merchantdashboard'
import Client from '@/views/components/client'
import companyProfile from '@/views/components/companyProfile'
import merchantProfile from '@/views/components/merchantProfile'
import inward from '@/views/components/inward'
import Role from '@/views/components/role'
import Merchant from '@/views/components/merchant'
import couriermapping from '@/views/components/couriermapping'
import categorymaster from '@/views/components/categorymaster'
import subcategorymaster from '@/views/components/subcategorymaster'
import User from '@/views/components/user'
import purchaseOrder from '@/views/components/purchaseOrder'
import printpo from '@/views/components/purchaseOrder/printpo'
import addPurchaseOrder from '@/views/components/purchaseOrder/addPurchaseOrder'
import editPurchaseOrder from '@/views/components/purchaseOrder/editPurchaseOrder'
import Pagination from '@/views/components/pagination'
import Import from '@/views/components/import'
import grc from '@/views/components/GRC'
import grc1 from '@/views/components/GRC1'
import GRCcorrection from '@/views/components/GRCcorrection'
import purchaseorderlist from '@/views/components/purchaseorderlist'
import warehousemaster from '@/views/components/warehousemaster'
import importCSV from '@/views/components/importCSV'
import packing from '@/views/components/packing'
import shippingdocs from '@/views/components/shippingdocs'
import productracklist from '@/views/components/productracklist'
//import orderdetails from '@/views/components/orderdetails'
import orderdetailstab from '@/views/components/orderdetailstab'
import orderdetailsAccordian from '@/views/components/orderdetailsAccordian'
import supplierMaster from '@/views/components/supplierMaster'
import product from '@/views/components/product'
import pushProduct from '@/views/components/pushProduct'
import goodsReceiptReport from '@/views/components/reports/goodsReceiptReport'
import grclotreport from '@/views/components/reports/grclotreport'
import grReport from '@/views/components/reports/grReport'
import putawayPending from '@/views/components/reports/putawayPending'
import salesReport from '@/views/components/reports/salesReport'
import shipmentHandoverReport from '@/views/components/reports/shipmentHandoverReport'
import stockreportclient from '@/views/components/reports/stockreportclient'
import stockreport from '@/views/components/reports/stockreport'
import orderreport from '@/views/components/reports/orderreport'
import stockenquiry from '@/views/components/reports/stockenquiry'
import order from '@/views/components/reports/order'
import orderlist from '@/views/components/reports/orderlist'
import backorderlist from '@/views/components/reports/backorderlist'
import brandwisestockreport from '@/views/components/reports/brandwisestockreport'
import daywisestockreport from '@/views/components/reports/daywisestockreport'
import itemnotfoundreport from '@/views/components/reports/itemnotfoundreport'
import GRrejectreport from '@/views/components/reports/GRrejectreport'
import pickingreport from '@/views/components/reports/pickingreport'
import packingreport from '@/views/components/reports/packingreport'
import poshortexcessreport from '@/views/components/reports/poshortexcessreport'
import warehouseStockReport from '@/views/components/reports/warehouseStockReport'
import rto from '@/views/components/rto'
import rtomarked from '@/views/components/rtomarked/rtolist'
import markrto from '@/views/components/rtomarked/markrto'
import changepassword from '@/views/components/changepassword'
import stockcorrection from '@/views/components/stockCorrection'
import config from '@/views/components/config'
import warehouseclient from '@/views/components/warehouseclient'
import productrackmaster from '@/views/components/productrackmaster'
import removehold from '@/views/components/removehold'
import notourproduct from '@/views/components/notourproduct'
import stockageingreport from '@/views/components/stockageingreport'
import RejectlistSRRTO from '@/views/components/RejectlistSRRTO'
import lpnmaster from '@/views/components/sr/lpnmaster'
import srmaster from '@/views/components/sr/srmaster'
import srqc from '@/views/components/sr/srqc'
import rejectreasonmaster from '@/views/components/sr/rejectreasonmaster'
import poputawayreport from '@/views/components/reports/poPutawayReport'
import userpermissions from '@/views/components/userpermissions'
import rackenquiry from '@/views/components/reports/rackenquiry'
import pickerassign from '@/views/components/pickerAssign'
import pickertransfer from '@/views/components/pickerTransfer'
import inwardEdit from '@/views/components/inwardEdit'
import cancelPutawayPending from '@/views/components/reports/cancelPutawayPendingReport'
import cancelputawayreport from '@/views/components/reports/cancelPutawayReport'
import notinporeport from '@/views/components/reports/notinporeport'
import returnsreceiptreport from '@/views/components/reports/returnsreceiptreport'

import productivitydrreport from '@/views/components/productivity report/productivitydrreport'
import productivitygrreport from '@/views/components/productivity report/productivitygrreport'
import productivitypackingreport from '@/views/components/productivity report/productivitypackingreport'
import productivitypickingreport from '@/views/components/productivity report/productivitypickingreport'
import productivityputawayreport from '@/views/components/productivity report/productivityputawayreport'
import productivityshippingreport from '@/views/components/productivity report/productivityshippingreport'
import rackauditreport from '@/views/components/reports/rackauditreport'
import detailedrackauditreport from '@/views/components/reports/detailedrackauditreport'
import rtoreport from '@/views/components/reports/rtoreport'
import requestedreport from '@/views/components/reports/requestedreport'
import productlogreport from '@/views/components/reports/productlogreport'
import shipment from '@/views/components/shipment'
import manifestdetails from '@/views/components/manifestdetails'
import printmanifestdetails from '@/views/components/manifestdetails/printmanifestdetails'

import shippinglabel from '@/views/components/shippinglabel' //created for shipping label

import datatransmissionlogreport from '@/views/components/datatransmissionlogreport'
import createsalesreturn from '@/views/components/createsalesreturn'
import receivedemail from '@/views/components/receivedemail'
import srreport from '@/views/components/reports/srreport'
import errorlogreport from '@/views/components/reports/errorlogreport'
import expiryreport from '@/views/components/reports/expiryreport'
import subinventorymaster from '@/views/components/subinventorymaster'
import stocktransferreport from '@/views/components/reports/stocktransferreport'
import stockcorrectionreport from '@/views/components/reports/stockcorrectionreport'
import rackZoneMaster from '@/views/components/rackZoneMaster'
import binmaster from '@/views/components/binmaster'
import batchCreation from '@/views/components/batchCreation'
import consorackmaster from '@/views/components/consorackmaster'
import consototemaster from '@/views/components/consototemaster'
import wavecreation from '@/views/components/wavecreation'
import shipmenthandover from '@/views/components/shipmenthandover'
import consopacking from '@/views/components/consopacking'
import supportrequest from '@/views/components/supportrequest'
import zonepickingreport from '@/views/components/zonepickingreport'
import rejectorderlist from '@/views/components/rejectorderlist'
import clientchannelmaster from '@/views/components/clientchannelmaster'
import clusterpickcollapse from '@/views/components/reports/clusterpickcollapse'
import unicominventorycomparisonreport from '@/views/components/reports/unicominventorycomparisonreport'
import osticket from '@/views/components/osticket'
import ticketlisting from '@/views/components/ticketlisting'
import addticket from '@/views/components/addticket'
import viewticket from '@/views/components/viewticket'
import grcLogReport from '@/views/components/reports/grcLogReport'
import manifesthandover from '@/views/components/manifesthandover'
import auditdiscrepancyreport from '@/views/components/reports/auditdiscrepancyreport'
import userslogindetails from '@/views/components/userslogindetails'



import unicommerceproduct from '@/views/components/uniware/unicommerceproduct'
import channelmapping from '@/views/components/uniware/channelmapping'
import newchannelmapping from '@/views/components/uniware/newchannelmapping'
import productstock from '@/views/components/uniware/productstock'

import multisellerorder from '@/views/components/multiseller/multisellerorder'
import ordertrackingflipkart from '@/views/components/reports/ordertrackingflipkart'
import auditdiscrepancylogreport from '@/views/components/reports/auditdiscrepancylogreport'
import pincodemapping from '@/views/components/pincodemapping'
import packingnew from '@/views/components/packingnew'
import packingb2b from '@/views/components/packingb2b'
import packingb2c from '@/views/components/packingb2c'
import inventorysyncingreport from '@/views/components/inventorysyncingreport'
import cameraapp from '@/views/components/cameraapp'
import rtogrn from '@/views/components/rtogrn'
import rtogrnb2b from '@/views/components/rtogrnb2b'
import ReturnInscan from '@/views/components/ReturnInscan'
import rejectreason from '@/views/components/rejectreason'
import brandwisestockexpiryreport from '@/views/components/reports/brandwisestockexpiryreport'
import rtoextraexcessproductreport from '@/views/components/reports/rtoextraexcessproductreport'
import uploadCsv from '@/views/components/uploadCsv'
import axios from 'axios';
import apiUrl from '@/constants';
import supportModule from '@/views/components/supportModule';
import multipickerassign from '@/views/components/multipickerassign';
import printpackdata from '@/views/components/packingnew/printpackdata';
import moveorderlist from '@/views/components/moveorderlist';
import pickPendingMoveorder from '@/views/components/reports/pickPendingMoveorder'
import activitylist from '@/views/components/activitylist';
import packingboxmaster from '@/views/components/packingboxmaster';
import transactionlogreport from '@/views/components/reports/transactionlogreport'
import packingb2bnew from '@/views/components/packingb2bnew';
import xpressathon from '@/views/components/xpressathon'
import activemrp from '@/views/components/activemrp'
import userproperties from '@/views/components/userproperties'
import reconciliationreport from '@/views/components/reconciliationreport'
import historicalreport from '@/views/components/historicalreport'
import virtualstockreport from '@/views/components/reports/virtualstockreport'
import notfound from '@/views/components/notfound'
import sla from '@/views/components/SLA'
import crossdockvisibility from '@/views/components/crossDockMaterialVisibility'
import wipInventory from '@/views/components/wipInventory'
import goodsreceiptcheck from '@/views/components/goodsreceiptcheck'
import slabreach from '@/views/components/slabreach'
import returnmanifest from '@/views/components/returnsmanifestlist/returnsmanifest'
import deleterequest from '@/views/components/deleterequest'
import inventoryReconciliation from '@/views/components/inventoryReconciliation'
import customstock from '@/views/components/customAudit'
import stockGrn from '@/views/components/stockGrn'
import stockgrnreport from '@/views/components/stockGrnReport'

Vue.use(Router)
const router = new Router({
	mode: 'hash',
	linkActiveClass: 'open active',
	scrollBehavior: () => ({
		y: 0
	}),
	routes: [{
		path: '/',
		redirect: '/dashboard',
		name: 'Home',
		component: Full,
		children: [{
			path: 'dashboard',
			name: 'dashboard',
			component: dashboard,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/dashboard'
				},
				{
					name: 'Dashboard'
				}
				],
				title: 'Dashboard'
			},
		},
		{
			path: 'invalidurl',
			name: 'invalidurl',
			component: invalidurl,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/invalidurl'
				},
				{
					name: 'invalidurl'
				}
				]
			},
		},
		{
			path: '/activemrplog',
			name: 'activemrplog',
			component: activemrp,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/activemrplog'
				},
				{
					name: 'activemrp'
				}
				],
				title: 'Active mrp'
			}
		},
		{
			path: '/notfound',
			name: 'notfound',
			component: notfound,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/notfound'
				},
				{
					name: 'notfound'
				}
				],
				title: 'Not Found'
			}
		},
		{
			path: '/wipInventory',
			name: 'wipInventory',
			component: wipInventory,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/wipInventory'
				},
				{
					name: 'WIP Inventory'
				}
				],
				title: 'WIP Inventory'
			}
		},
		{
			path: '/ReturnInscan',
			name: 'ReturnInscan',
			component: ReturnInscan,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/ReturnInscan'
				},
				{
					name: 'ReturnInscan'
				}
				],
				title: 'ReturnInscan'
			}
		},
		{
			path: '/notourproduct',
			name: 'notourproduct',
			component: notourproduct,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/notourproduct'
				},
				{
					name: 'not our product'
				}
				],
				title: 'not our product'
			}
		},

		{
			path: '/RejectlistSRRTO',
			name: 'RejectlistSRRTO',
			component: RejectlistSRRTO,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/RejectlistSRRTO'
				},
				{
					name: 'Rejectlist RTO RVP'
				}
				],
				title: 'Rejectlist RTO RVP'
			}
		},
		{
			path: 'merchantdashboard',
			name: 'merchantdashboard',
			component: Merchantdashboard,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/merchantdashboard'
				},
				{
					name: 'Merchant Dashboard'
				}
				],
				title: 'Merchant Dashboard'
			}
		},

		{
			path: '/falseblockedrackstock',
			name: 'falseblockedrackstock',
			component: falseblockedrackstock,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/falseblockedrackstock'
				},
				{
					name: 'False blocked rack stock  Report'
				}
				],
				title: ' False blocked rack stock Report'
			}
		},
		{
			path: '/invoiceErrorReport',
			name: 'invoiceErrorReport',
			component: invoiceErrorReport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/invoiceErrorReport'
				},
				{
					name: 'Invoice Error Report'
				}
				],
				title: 'Invoice Error Report'
			}
		},
		{
			path: 'pagination',
			name: 'Pagination',
			component: Pagination,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/pagination'
				},
				{
					name: 'Pagination'
				}
				]
			}
		},
		// {
		// 	path: '/orderdetails/:poid',
		// 	name: 'orderdetails',
		// 	component: orderdetails,
		// 	meta: {
		// 		breadcrumb: [{
		// 				name: 'Home',
		// 				link: '/orders'
		// 			},
		// 			{
		// 				name: 'Orderdetails'
		// 			}
		// 		],
		// 		title: 'Order Details'
		// 	}
		// },
		// {
		// 	path: '/orderdetailstab/:poid',
		// 	name: 'orderdetailstab',
		// 	component: orderdetailstab,
		// 	meta: {
		// 		breadcrumb: [{
		// 				name: 'Home',
		// 				link: '/orders'
		// 			},
		// 			{
		// 				name: 'orderdetailstab'
		// 			}
		// 		],
		// 		title: 'Order Details Tab'
		// 	}
		// },
		{
			path: '/orderdetailsAccordian/:poid',
			name: 'orderdetailsAccordian',
			component: orderdetailsAccordian,
			meta: {
				breadcrumb: [{
					name: 'Home',
					link: '/orders'
				},
				{
					name: 'Order Details Accordian'
				}
				],
				title: 'Order Details Accordian'
			}
		},
		// camera app
		{
			path: '/cameraapp',
			name: 'cameraapp',
			component: cameraapp,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/cameraapp'
				},
				{
					name: 'Camera App'
				}
				],
				title: 'Camera App'
			}
		},
		{
			path: '/brandwisestockexpiryreport',
			name: 'brandwisestockexpiryreport',
			component: brandwisestockexpiryreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/brandwisestockexpiryreport'
				},
				{
					name: 'Brand Wise Stock Expiry Report'
				}
				],
				title: 'Brand Wise Stock Expiry Report'
			}
		},
		{
			path: '/moveorderlist',
			name: 'moveorderlist',
			component: moveorderlist,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/moveorderlist'
				},
				{
					name: 'Move Order List'
				}
				],
				title: 'Move Order List'
			}
		},
		{
			path: '/stockageingreport',
			name: 'stockageingreport',
			component: stockageingreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/stockageingreport'
				},
				{
					name: 'stockageingreport'
				}
				],
				title: 'stockageingreport'
			}
		},
		{
			path: '/manifesthandover',
			name: 'manifesthandover',
			component: manifesthandover,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/manifesthandover'
				},
				{
					name: 'Manifest Handover'
				}
				],
				title: 'Manifest Handover'
			}
		},
		{
			path: 'shipment',
			name: 'shipment',
			component: shipment,
			meta: {
				breadcrumb: [{
					name: 'Home',
					link: '/shipment'
				},
				{
					name: 'Shipment'
				}
				],
				title: 'Shipment'
			}
		},
		{
			path: 'manifestdetails',
			name: 'manifestdetails',
			component: manifestdetails,
			meta: {
				breadcrumb: [{
					name: 'Home',
					link: '/manifestdetails'
				},
				{
					name: 'Manifest Report'
				}
				],
				title: 'Manifest Report'
			}
		},
		{
			path: 'userslogindetails',
			name: 'userslogindetails',
			component: userslogindetails,
			meta: {
				breadcrumb: [{
					name: 'Home',
					link: '/userslogindetails'
				},
				{
					name: 'Login Users'
				}
				],
				title: 'Login Users'
			}
		},
		{
			path: '/rejectorderlist',
			name: 'rejectorderlist',
			component: rejectorderlist,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/rejectorderlist'
				},
				{
					name: 'Reject Orders List'
				}
				],
				title: 'Reject Orders List'
			}
		},
		{
			path: '/rejectreason',
			name: 'rejectreason',
			component: rejectreason,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/rejectreason'
				},
				{
					name: 'Reject Reason Management'
				}
				],
				title: 'Reject Reason Management'
			}
		},
		{
			path: '/clientchannelmaster',
			name: 'clientchannelmaster',
			component: clientchannelmaster,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/clientchannelmaster'
				},
				{
					name: 'Client Channel Master'
				}
				],
				title: 'Client Channel Master'
			}
		},
		{
			path: '/clusterpickcollapse',
			name: 'clusterpickcollapse',
			component: clusterpickcollapse,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/clusterpickcollapse'
				},
				{
					name: 'Cluster Picking Report'
				}
				],
				title: 'Cluster Picking Report'
			}
		},
		{
			path: '/unicominventorycomparisonreport',
			name: 'unicominventorycomparisonreport',
			component: unicominventorycomparisonreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/unicominventorycomparisonreport'
				},
				{
					name: 'Unicom Inventory Comparison Report'
				}
				],
				title: 'Unicom Inventory Comparison Report'
			}
		},
		{
			path: 'subinventorymaster',
			name: 'subinventorymaster',
			component: subinventorymaster,
			meta: {
				breadcrumb: [{
					name: 'Home',
					link: '/subinventorymaster'
				},
				{
					name: 'Sub Inventory Master'
				}
				],
				title: 'Sub Inventory Master'
			}
		},
		{
			path: '/printmanifestdetails/:id',
			name: 'printmanifestdetails',
			component: printmanifestdetails,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/manifestdetails'
				},
				{
					name: 'Print ManifestDetails'
				}
				],
				title: 'Print ManifestDetails'
			}
		},
		{
			path: '/merchant',
			name: 'merchant',
			component: Merchant,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/merchant'
				},
				{
					name: 'Merchants'
				}
				],
				title: 'Merchants'
			}
		},
		{
			path: '/pushProduct',
			name: 'pushProduct',
			component: pushProduct,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/product'
				},
				{
					name: 'Push Product'
				}
				],
				title: 'Push Product'
			}
		},
		{
			path: '/client',
			name: 'client',
			component: Client,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/client'
				},
				{
					name: 'Clients'
				}
				],
				title: 'Clients'
			}
		},
		{
			path: '/warehousemaster',
			name: 'warehousemaster',
			component: warehousemaster,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/warehousemaster'
				},
				{
					name: 'Warehouses'
				}
				],
				title: 'Warehouses'
			}
		},
		{
			path: '/categorymaster',
			name: 'categorymaster',
			component: categorymaster,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/categorymaster'
				},
				{
					name: 'Products Category'
				}
				],
				title: 'Products Category'
			}
		},
		{
			path: '/couriermapping',
			name: 'couriermapping',
			component: couriermapping,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/couriermapping'
				},
				{
					name: 'Courier Mapping'
				}
				],
				title: 'Courier Mapping'
			}
		},
		{
			path: '/subcategorymaster',
			name: 'subcategorymaster',
			component: subcategorymaster,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/subcategorymaster'
				},
				{
					name: 'Products Sub-category'
				}
				],
				title: 'Products Subcategory'
			}
		},
		{
			path: '/binmaster',
			name: 'binmaster',
			component: binmaster,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/binmaster'
				},
				{
					name: 'Bin Master'
				}
				],
				title: 'Bin Master'
			}
		},
		{
			path: '/inward',
			name: 'inward',
			component: inward,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/inwardlist'
				},
				{
					name: 'Inward'
				}
				],
				title: 'Inward'
			}
		},
		{
			path: '/ticketlisting',
			name: 'ticketlisting',
			component: ticketlisting,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/ticketlisting'
				},
				{
					name: 'Ticket Listing'
				}
				],
				title: 'Ticket listing'
			}
		},
		{
			path: '/addticket',
			name: 'addticket',
			component: addticket,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/ticketlisting'
				},
				{
					name: 'Add Ticket'
				}
				],
				title: 'Add Ticket'
			}
		},
		{
			path: '/viewticket',
			name: 'viewticket',
			component: viewticket,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/ticketlisting'
				},
				{
					name: 'Ticket Details'
				}
				],
				title: 'View Ticket'
			}
		},
		{
			path: '/inwardlist',
			name: 'inwardlist',
			component: inwardlist,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/inwardlist'
				},
				{
					name: 'Dock Receipt'
				}
				],
				title: 'Dock Receipt'
			}
		},
		{
			path: '/companyProfile',
			name: 'companyProfile',
			component: companyProfile,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/companyProfile'
				},
				{
					name: 'Company Profile'
				}
				],
				title: 'Company Profile'
			}
		},
		{
			path: '/config',
			name: 'config',
			component: config,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/config'
				},
				{
					name: 'Config'
				}
				],
				title: 'Config'
			}
		},
		{
			path: '/merchantProfile',
			name: 'merchantProfile',
			component: merchantProfile,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/merchantProfile'
				},
				{
					name: 'Merchant Profile'
				}
				],
				title: 'Merchant Profile'
			}
		},
		{
			path: '/user',
			name: 'user',
			component: User,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/user'
				},
				{
					name: 'Users'
				}
				],
				title: 'Users'
			}
		},
		{
			path: '/changepassword',
			name: 'changepassword',
			component: changepassword,
			meta: {
				breadcrumb: [{
					name: 'Home',
					link: '/changepassword'
				},
				{
					name: 'Change Password'
				}
				],
				title: 'Change Password'
			}
		},
		{
			path: '/role',
			name: 'role',
			component: Role,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/role'
				},
				{
					name: 'Roles'
				}
				],
				title: 'Roles'
			}
		},
		{
			path: '/import',
			name: 'import',
			component: Import,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/import'
				},
				{
					name: 'Import'
				}
				],
				title: 'Import'
			}
		},
		{
			path: '/importcsv',
			name: 'importcsv',
			component: importCSV,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/importcsv'
				},
				{
					name: 'Import CSV'
				}
				],
				title: 'Import CSV'
			}
		},
		{
			path: '/supportModule',
			name: 'supportModule',
			component: supportModule,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/supportModule'
				},
				{
					name: 'Support Module'
				}
				],
				title: 'Support Module'
			}
		},
		{
			path: '/osticket',
			name: 'osticket',
			component: osticket,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/ticketlisting'
				},
				{
					name: 'OS Ticket'
				}
				],
				title: 'OS Ticket'
			}
		},
		{
			path: '/pickerassignment',
			name: 'pickerassign',
			component: pickerassign,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/pickerassignment'
				},
				{
					name: 'Picker Assignment'
				}
				],
				title: 'Picker Assignment'
			}
		},
		{
			path: '/wavecreation',
			name: 'wavecreation',
			component: wavecreation,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/wavecreation'
				},
				{
					name: 'Wave Creation'
				}
				],
				title: 'Wave Creation'
			}
		},
		{
			path: '/batchCreation',
			name: 'batchCreation',
			component: batchCreation,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/batchCreation'
				},
				{
					name: 'Create Batch'
				}
				],
				title: 'Create Batch'
			}
		},
		{
			path: '/pickertransfer',
			name: 'pickertransfer',
			component: pickertransfer,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/pickertransfer'
				},
				{
					name: 'Picker Transfer'
				}
				],
				title: 'Picker Transfer'
			}
		},
		{
			path: '/purchaseOrder',
			name: 'purchaseOrder',
			component: purchaseOrder,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/purchaseOrder'
				},
				{
					name: 'Purchase Order'
				}
				],
				title: 'Purchase Order'
			}
		},
		{
			path: '/rtomarked',
			name: 'rtomarked',
			component: rtomarked,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/rtomarked'
				},
				{
					name: 'RTO Marked'
				}
				],
				title: 'RTO Marked'
			}
		},
		{
			path: '/markrto',
			name: 'markrto',
			component: markrto,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/markrto'
				},
				{
					name: 'Mark RTO'
				}
				],
				title: 'Mark RTO'
			}
		},
		{
			path: '/rtoreport',
			name: 'rtoreport',
			component: rtoreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/rtoreport'
				},
				{
					name: 'RTO Report'
				}
				],
				title: 'RTO Report'
			}
		},
		{
			path: '/srreport',
			name: 'srreport',
			component: srreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/srreport'
				},
				{
					name: 'SR Report'
				}
				],
				title: 'SR Report'
			}
		},
		{
			path: '/expiryreport',
			name: 'expiryreport',
			component: expiryreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/dashboard'
				},
				{
					name: 'Product Expiry Report'
				}
				],
				title: 'Product Expiry Report'
			}
		},
		{
			path: '/errorlogreport',
			name: 'errorlogreport',
			component: errorlogreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/dashboard'
				},
				{
					name: 'Error Log Report'
				}
				],
				title: 'Error Log Report'
			}
		},
		{
			path: '/transactionlogreport',
			name: 'transactionlogreport',
			component: transactionlogreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/dashboard'
				},
				{
					name: 'Transaction Log Report'
				}
				],
				title: 'Transaction Log Report'
			}
		},
		{
			path: '/addPurchaseOrder',
			name: 'addPurchaseOrder',
			component: addPurchaseOrder,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/purchaseOrder'
				},
				{
					name: 'Add PurchaseOrder'
				}
				],
				title: 'Add PurchaseOrder'
			}
		},
		{
			path: '/printpo/:pono',
			name: 'printpo',
			component: printpo,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/purchaseOrder'
				},
				{
					name: 'Printpo'
				}
				],
				title: 'Print PO'
			}
		},
		{
			path: '/editPurchaseOrder/:pono',
			name: 'editPurchaseOrder',
			component: editPurchaseOrder,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/purchaseOrder'
				},
				{
					name: 'Edit PurchaseOrder'
				}
				],
				title: 'Edit PurchaseOrder'
			}
		},
		{
			path: '/orders',
			name: 'orders',
			component: order,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/orders'
				},
				{
					name: 'Orders'
				}
				],
				title: 'Orders'
			}
		},
		{
			path: '/rackZoneMaster',
			name: 'rackZoneMaster',
			component: rackZoneMaster,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/rackZoneMaster'
				},
				{
					name: 'Rack Zone Master'
				}
				],
				title: 'Rack Zone Master'
			}
		},
		{
			path: '/pincodemapping',
			name: 'pincodemapping',
			component: pincodemapping,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/pincodemapping'
				},
				{
					name: 'Warehouse Pin Code Mapping'
				}
				],
				title: 'Warehouse Pin Code Mapping'
			}
		},

		{
			path: '/consorackmaster',
			name: 'consorackmaster',
			component: consorackmaster,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/consorackmaster'
				},
				{
					name: 'Conso Rack Master'
				}
				],
				title: 'Conso Rack Master'
			}
		},
		{
			path: '/consototemaster',
			name: 'consototemaster',
			component: consototemaster,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/consototemaster'
				},
				{
					name: 'TOT ID Master'
				}
				],
				title: 'TOT ID Master'
			}
		},
		{
			path: '/zonepickingreport',
			name: 'zonepickingreport',
			component: zonepickingreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/zonepickingreport'
				},
				{
					name: 'Zone Picking Report'
				}
				],
				title: 'Zone Picking Report'
			}
		},
		{
			path: '/orderlist',
			name: 'orderlist',
			component: orderlist,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/orderlist'
				},
				{
					name: 'Order List'
				}
				],
				title: 'Order List'
			}
		},
		// {
		// 	path: '/orderdetails',
		// 	name: 'orderdetails',
		// 	component: orderdetails,
		// 	meta: {
		// 		requiresAuth: true,
		// 		breadcrumb: [{
		// 				name: 'Home',
		// 				link: '/orderdetails'
		// 			},
		// 			{
		// 				name: 'Order Details'
		// 			}
		// 		]
		// 	}
		// },
		{
			path: '/backorderlist',
			name: 'backorderlist',
			component: backorderlist,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/backorderlist'
				},
				{
					name: 'Back Order List'
				}
				],
				title: 'Back Order List'
			}
		},
		{
			path: '/grc/:drno',
			name: 'grc',
			component: grc,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/grc'
				},
				{
					name: 'GRC'
				}
				],
				title: 'GRC'
			}
		},
		{
			path: '/GRCcorrection',
			name: 'GRCcorrection',
			component: GRCcorrection,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/GRCcorrection'
				},
				{
					name: 'GRC Correction'
				}
				],
				title: 'GRC Correction'
			}
		},
		{
			path: '/grc1/:drno',
			name: 'grc1',
			component: grc1,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/inwardlist'
				},
				{
					name: 'GRC'
				}
				],
				title: 'GRC'
			}
		},
		{
			path: '/grclist',
			name: 'grclist',
			component: grclist,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/grclist'
				},
				{
					name: 'Goods Receipt'
				}
				],
				title: 'Goods Receipt'
			}
		},
		{
			path: '/packing',
			name: 'packing',
			component: packing,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/packing'
				},
				{
					name: 'Packing'
				}
				],
				title: 'Packing'
			}
		},
		{
			path: '/packingnew',
			name: 'packingnew',
			component: packingnew,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/packingnew'
				},
				{
					name: 'Packing'
				}
				],
				title: 'Packing'
			}
		},
		{
			path: '/packingb2c',
			name: 'packingb2c',
			component: packingb2c,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/packingb2c'
				},
				{
					name: 'Packing B2C'
				}
				],
				title: 'Packing B2C'
			}
		},
		{
			path: '/packingb2b',
			name: 'packingb2b',
			component: packingb2b,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/packingb2b'
				},
				{
					name: 'packingb2b'
				}
				],
				title: 'packingb2b'
			}
		},
		{
			path: '/packingnewb2b',
			name: 'packingnewb2b',
			component: packingb2bnew,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/packingnewb2b'
				},
				{
					name: 'packingb2bnew'
				}
				],
				title: 'packingb2bnew'
			}
		},

		{
			path: '/printpackdata',
			name: 'printpackdata',
			component: printpackdata,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/printpackdata'
				},
				{
					name: 'printpackdata'
				}
				],
				title: 'Print Packing Data'
			}
		},
		{
			path: '/shippingdocs',
			name: 'shippingdocs',
			component: shippingdocs,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/shippingdocs'
				},
				{
					name: 'Shippingdocs'
				}
				],
				title: 'Shippingdocs'
			}
		},
		{
			path: '/rto',
			name: 'rto',
			component: rto,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/rto'
				},
				{
					name: 'RTO'
				}
				],
				title: 'RTO'
			}
		},
		{
			path: '/rtogrn',
			name: 'rtogrn',
			component: rtogrn,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/rtogrn'
				},
				{
					name: 'Create GRN'
				}
				],
				title: 'Create GRN'
			}
		},
		{
			path: '/rtogrnb2b',
			name: 'rtogrnb2b',
			component: rtogrnb2b,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/rtogrnb2b'
				},
				{
					name: 'Create GRN B2B'
				}
				],
				title: 'Create GRN B2B'
			}
		},
		{
			path: '/returnmanifest',
			name: 'returnmanifest',
			component: returnmanifest,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/returnmanifest'
				},
				{
					name: 'returnmanifest'
				}
				],
				title: 'Returns Manifest'
			}
		},
		{
			path: '/lpnmaster',
			name: 'lpnmaster',
			component: lpnmaster,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/lpnmaster'
				},
				{
					name: 'Create LPN'
				}
				],
				title: ' Create LPN '
				//  adminAuth: "sr"
			}
		},
		{
			path: '/srmaster',
			name: 'srmaster',
			component: srmaster,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/srmaster'
				},
				{
					name: 'SR Master'
				}
				],
				title: 'SR Master'
				//  adminAuth: "sr"
			}
		},
		{
			path: '/srqc',
			name: 'srqc',
			component: srqc,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/srqc'
				},
				{
					name: 'Customer Returns'
				}
				],
				title: 'Customer Returns'
				//  adminAuth: "sr"
			}
		},
		{
			path: '/rejectreasonmaster',
			name: 'rejectreasonmaster',
			component: rejectreasonmaster,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/rejectreasonmaster'
				},
				{
					name: 'SR Reject Reason'
				}
				],
				title: 'SR Reject Reason'
				//  adminAuth: "sr"
			}
		},
		{
			path: 'shippinglabel',
			name: 'shippinglabel',
			component: shippinglabel,
			meta: {
				breadcrumb: [{
					name: 'Home',
					link: '/shippinglabel'
				},
				{
					name: 'Shipping Label'
				}
				],
				title: 'Shipping Label'
			}
		},
		{
			path: '/boxtype',
			name: 'boxtype',
			component: boxtype,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/boxtype'
				},
				{
					name: 'Create Box'
				}
				],
				title: 'Create Box'
			}
		},

		{
			path: '/shippingDetails',
			name: 'shippingDetails',
			component: shippingDetails,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/shippingDetails'
				},
				{
					name: 'Shipping Details'
				}
				],
				title: 'Shipping Details'
			}
		},
		{
			path: '/stnboxtype',
			name: 'stnboxtype',
			component: stnboxtype,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/stnboxtype'
				},
				{
					name: 'Create STN Box'
				}
				],
				title: 'Create STN Box'
			}
		},
		{
			path: '/supplierMaster',
			name: 'supplierMaster',
			component: supplierMaster,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/supplierMaster'
				},
				{
					name: 'Supplier Master'
				}
				],
				title: 'Supplier Master'
			}
		},
		{
			path: '/product',
			name: 'product',
			component: product,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/product'
				},
				{
					name: 'Products'
				}
				],
				title: 'Products'
			}
		},
		{
			path: '/stocktransfer',
			name: 'stocktransfer',
			component: stocktransfer,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/stocktransfer'
				},
				{
					name: 'Stock Transfer'
				}
				],
				title: 'Stock Transfer'
			}
		},
		{
			path: '/sourceSTNreport',
			name: 'sourceSTNreport',
			component: sourceSTNreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/sourceSTNreport'
				},
				{
					name: 'Source STN Report'
				}
				],
				title: 'Source STN Report'
			}
		},
		{
			path: '/stockreport',
			name: 'stockreport',
			component: stockreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/stockreport'
				},
				{
					name: 'Stock Report'
				}
				],
				title: 'Stock Report'
			}
		},
		{
			path: '/brandwisestockreport',
			name: 'brandwisestockreport',
			component: brandwisestockreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/brandwisestockreport'
				},
				{
					name: 'Brand Wise Stock Report'
				}
				],
				title: 'Brand Wise Stock Report'
			}
		},
		{
			path: '/auditdiscrepancylogreport',
			name: 'auditdiscrepancylogreport',
			component: auditdiscrepancylogreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/auditdiscrepancylogreport'
				},
				{
					name: 'auditdiscrepancylogreport'
				}
				],
				title: 'auditdiscrepancylogreport'
			}
		},
		{
			path: '/stocktransferreport',
			name: 'stocktransferreport',
			component: stocktransferreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/stocktransferreport'
				},
				{
					name: 'Stock Transfer Report'
				}
				],
				title: 'Stock Transfer Report'
			}
		},
		{
			path: '/stockcorrectionreport',
			name: 'stockcorrectionreport',
			component: stockcorrectionreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/stockcorrectionreport'
				},
				{
					name: 'Stock Correction Report'
				}
				],
				title: 'Stock Correction Report'
			}
		},
		{
			path: '/rtoextraexcessproductreport',
			name: 'rtoextraexcessproductreport',
			component: rtoextraexcessproductreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/rtoextraexcessproductreport'
				},
				{
					name: 'RTO/RVP Extra Excess Product Report'
				}
				],
				title: 'RTO/RVP Extra Excess Product report'
			}
		},
		{
			path: '/daywisestockreport',
			name: 'daywisestockreport',
			component: daywisestockreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/daywisestockreport'
				},
				{
					name: 'Day Wise Stock Report'
				}
				],
				title: 'Day Wise Stock Report'
			}
		},
		{
			path: '/itemnotfoundreport',
			name: 'itemnotfoundreport',
			component: itemnotfoundreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/itemnotfoundreport'
				},
				{
					name: ' Not Found Report'
				}
				],
				title: ' Not Found Report'
			}
		},

		{
			path: '/GRrejectreport',
			name: 'GRrejectreport',
			component: GRrejectreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/GRrejectreport'
				},
				{
					name: 'GR reject Report'
				}
				],
				title: 'GR reject Report'
			}
		},
		{
			path: '/pickingreport',
			name: 'pickingreport',
			component: pickingreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/pickingreport'
				},
				{
					name: 'Picking Report'
				}
				],
				title: 'Picking Report'
			}
		},
		{
			path: '/packingreport',
			name: 'packingreport',
			component: packingreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/packingreport'
				},
				{
					name: 'Packing Report'
				}
				],
				title: 'Packing Report'
			}
		},
		{
			path: '/poshortexcessreport',
			name: 'poshortexcessreport',
			component: poshortexcessreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/poshortexcessreport'
				},
				{
					name: 'poshortexcessreport'
				}
				],
				title: 'Poshortexcess Report'
			}
		},
		{
			path: '/warehouseStockReport',
			name: 'warehouseStockReport',
			component: warehouseStockReport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/warehouseStockReport'
				},
				{
					name: 'Warehouse Stock Report'
				}
				],
				title: 'Warehouse Stock Report'
			}
		},
		{
			path: '/putawayPending',
			name: 'putawayPending',
			component: putawayPending,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/putawayPending'
				},
				{
					name: 'Putaway Pending'
				}
				],
				title: 'Putaway Pending'
			}
		},
		{
			path: '/cancelPutawayPending',
			name: 'cancelPutawayPending',
			component: cancelPutawayPending,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/cancelPutawayPending'
				},
				{
					name: 'Cancel Putaway Pending'
				}
				],
				title: 'Cancel Putaway Pending'
			}
		},
		{
			path: '/cancelputawayreport',
			name: 'cancelputawayreport',
			component: cancelputawayreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/cancelputawayreport'
				},
				{
					name: 'Cancel Putaway'
				}
				],
				title: 'Cancel Putaway '
			}
		},
		{
			path: '/shipmentHandoverReport',
			name: 'shipmentHandoverReport',
			component: shipmentHandoverReport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/shipmentHandoverReport'
				},
				{
					name: 'Shipment Handover Report'
				}
				],
				title: 'Shipment Handover Report'
			}
		},
		{
			path: '/supportrequest',
			name: 'supportrequest',
			component: supportrequest,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/supportrequest'
				},
				{
					name: 'Support Request'
				}
				],
				title: 'Support Request'
			}
		},
		{
			path: '/deleterequest',
			name: 'deleterequest',
			component: deleterequest,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/deleterequest'
				},
				{
					name: 'Delete Request'
				}
				],
				title: 'Delete Request'
			}
		},
		{
			path: '/shipmenthandover',
			name: 'shipmenthandover',
			component: shipmenthandover,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/shipmenthandover'
				},
				{
					name: 'Shipment Handover'
				}
				],
				title: 'Shipment Handover'
			}
		},
		{
			path: '/consopacking',
			name: 'consopacking',
			component: consopacking,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/consopacking'
				},
				{
					name: 'Conso Packing'
				}
				],
				title: 'Conso Packing'
			}
		},
		{
			path: '/goodsReceiptReport',
			name: 'goodsReceiptReport',
			component: goodsReceiptReport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/goodsReceiptReport'
				},
				{
					name: 'Goods Receipt Report'
				}
				],
				title: 'Goods Receipt Report'
			}
		},
		{
			path: '/grcLogReport',
			name: 'grcLogReport',
			component: grcLogReport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/grcLogReport'
				},
				{
					name: 'GRC Log Report'
				}
				],
				title: 'GRC Log Report'
			}
		},
		{
			path: '/stockenquiry',
			name: 'stockenquiry',
			component: stockenquiry,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/stockenquiry'
				},
				{
					name: 'Stock Enquiry'
				}
				],
				title: 'Stock Enquiry'
			}
		},
		{
			path: '/rackenquiry',
			name: 'rackenquiry',
			component: rackenquiry,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/rackenquiry'
				},
				{
					name: 'Rack Stock Enquiry'
				}
				],
				title: 'Rack Stock Enquiry'
			}
		},
		{
			path: '/grReport',
			name: 'grReport',
			component: grReport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/grReport'
				},
				{
					name: 'GR Report'
				}
				],
				title: 'GR Report'
			}
		},
		{
			path: '/salesReport',
			name: 'salesReport',
			component: salesReport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/salesReport'
				},
				{
					name: 'Sales Report'
				}
				],
				title: 'Sales Report'
			}
		},
		{
			path: '/stockreportclient',
			name: 'stockreportclient',
			component: stockreportclient,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/stockreportclient'
				},
				{
					name: 'stockreportclient'
				}
				],
				title: 'Stock Report Client'
			}
		},
		{
			path: '/grclotreport',
			name: 'grclotreport',
			component: grclotreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/grclotreport'
				},
				{
					name: 'GRC Lot report'
				}
				],
				title: 'GRC Lot report'

			}
		},
		{
			path: '/notinporeport',
			name: 'notinporeport',
			component: notinporeport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/notinporeport'
				},
				{
					name: 'GRC(Not IN PO) Report'
				}
				],
				title: 'GRC(Not IN PO) Report'
			}
		},
		{
			path: '/rackauditreport',
			name: 'rackauditreport',
			component: rackauditreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/rackauditreport'
				},
				{
					name: 'Rack Audit Report'
				}
				],
				title: 'Rack Audit Report'
			}
		},
		{
			path: '/detailedrackauditreport',
			name: 'detailedrackauditreport',
			component: detailedrackauditreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/detailedrackauditreport'
				},
				{
					name: 'Detailed Rack Audit Report'
				}
				],
				title: 'Detailed Rack Audit Report'
			}
		},
		{
			path: '/auditdiscrepancyreport',
			name: 'auditdiscrepancyreport',
			component: auditdiscrepancyreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/auditdiscrepancyreport'
				},
				{
					name: 'Rack Audit Discrepancy report'
				}
				],
				title: 'Rack Audit Discrepancy report'
			}
		},
		{
			path: '/productlogreport',
			name: 'productlogreport',
			component: productlogreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/productlogreport'
				},
				{
					name: 'Product Log Report'
				}
				],
				title: 'Product Log Report'
			}
		},
		{
			path: '/purchaseorderlist',
			name: 'purchaseorderlist',
			component: purchaseorderlist,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/purchaseorderlist'
				},
				{
					name: 'Purchase Order Report'
				}
				],
				title: 'Purchase Order Report'
			}
		},

		{
			path: '/productivitydrreport',
			name: 'productivitydrreport',
			component: productivitydrreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/productivitydrreport'
				},
				{
					name: 'Productivity DR Report'
				}
				],
				title: 'Productivity DR Report'
			}
		},
		{
			path: '/productivitygrreport',
			name: 'productivitygrreport',
			component: productivitygrreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/productivitygrreport'
				},
				{
					name: 'Productivity GR Report'
				}
				],
				title: 'Productivity GR Report'
			}
		},
		{
			path: '/productivitypackingreport',
			name: 'productivitypackingreport',
			component: productivitypackingreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/productivitypackingreport'
				},
				{
					name: 'Productivity Packing Report'
				}
				],
				title: 'Productivity Packing Report'
			}
		},
		{
			path: '/productivitypickingreport',
			name: 'productivitypickingreport',
			component: productivitypickingreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/productivitypickingreport'
				},
				{
					name: 'Productivity Picking Report'
				}
				],
				title: 'Productivity Picking Report'
			}
		},
		{
			path: '/productivityputawayreport',
			name: 'productivityputawayreport',
			component: productivityputawayreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/productivityputawayreport'
				},
				{
					name: 'Productivity Putaway Report'
				}
				],
				title: 'Productivity Putaway Report'
			}
		},
		{
			path: '/datatransmissionlogreport',
			name: 'datatransmissionlogreport',
			component: datatransmissionlogreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/datatransmissionlogreport'
				},
				{
					name: 'Data Upload Logs'
				}
				],
				title: 'Data Upload Logs'
			}
		},
		{
			path: '/inventorysyncingreport',
			name: 'inventorysyncingreport',
			component: inventorysyncingreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/inventorysyncingreport'
				},
				{
					name: 'Inventory Sync Log Report'
				}
				],
				title: 'Inventory Sync Log Report'
			}
		},
		{
			path: '/createsalesreturn',
			name: 'createsalesreturn',
			component: createsalesreturn,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/srmaster'
				},
				{
					name: 'Create Sales Return'
				}
				],
				title: 'Create Sales Return'
			}
		},
		{
			path: '/receivedemail',
			name: 'receivedemail',
			component: receivedemail,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/receivedemail'
				},
				{
					name: 'Received Email'
				}
				],
				title: 'Received Email'
			}
		},
		{
			path: '/productivityshippingreport',
			name: 'productivityshippingreport',
			component: productivityshippingreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/productivityshippingreport'
				},
				{
					name: 'Productivity Shipping Report'
				}
				],
				title: 'Productivity Shipping Report'
			}
		},
		{
			path: '/returnsreceiptreport',
			name: 'returnsreceiptreport',
			component: returnsreceiptreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/returnsreceiptreport'
				},
				{
					name: 'returnsreceiptreport'
				}
				],
				title: 'Returns Receipt Report'
			}
		},
		{
			path: '/orderreport',
			name: 'orderreport',
			component: orderreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/orderreport'
				},
				{
					name: 'Order Report'
				}
				],
				title: 'Order Report'
			}
		},
		{
			path: '/slabreach',
			name: 'slabreach',
			component: slabreach,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/slabreach'
				},
				{
					name: 'SLA Breach Analysis'
				}
				],
				title: 'SLA Breach Analysis'
			}
		},
		{
			path: '/inventoryReconciliation',
			name: 'inventoryReconciliation',
			component: inventoryReconciliation,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/inventoryReconciliation'
				},
				{
					name: 'Inventory Reconciliation Report'
				}
				],
				title: 'Inventory Reconciliation Report'
			}
		},
		{
			path: '/stockcorrection',
			name: 'stockcorrection',
			component: stockcorrection,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/stockcorrection'
				},
				{
					name: 'Stock Correction'
				}
				],
				title: 'Stock Correction'
			}
		},
		{
			path: '/warehouseclient',
			name: 'warehouseclient',
			component: warehouseclient,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/warehouseclient'
				},
				{
					name: 'Warehouse Client'
				}
				],
				title: 'Warehouse Client'
			}
		},
		{
			path: '/productrackmaster',
			name: 'productrackmaster',
			component: productrackmaster,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/productrackmaster'
				},
				{
					name: 'Warehouse Rack'
				}
				],
				title: 'Warehouse Rack'
			}
		},
		{
			path: '/userpermissions',
			name: 'userpermissionsuserpermissions',
			component: userpermissions,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/userpermissions'
				},
				{
					name: 'User Permissions'
				}
				],
				title: 'User Permissions'
			}
		},
		{
			path: '/userproperties',
			name: 'User Properties',
			component: userproperties,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/userproperties'
				},
				{
					name: 'User Properties'
				}
				],
				title: 'User Properties'
			}
		},
		{
			path: '/virtualstockreport',
			name: 'Virtual Stockreport',
			component: virtualstockreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/virtualstockreport'
				},
				{
					name: 'Virtual Stockreport'
				}
				],
				title: 'virtualstockreport'
			}
		}, 
		{
			path: '/removehold',
			name: 'removehold',
			component: removehold,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/removehold'
				},
				{
					name: 'Remove Hold'
				}
				],
				title: 'Remove Hold'
			}
		},
		{
			path: '/poputawayreport',
			name: 'poputawayreport',
			component: poputawayreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/poputawayreport'
				},
				{
					name: 'PO Putaway Report'
				}
				],
				title: 'PO Putaway Report'
			}
		},
		{
			path: '/inwardEdit',
			name: 'inwardEdit',
			component: inwardEdit,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/inwardlist'
				},
				{
					name: 'Inward Edit'
				}
				],
				title: 'Inward Edit'
			}
		},
		{
			path: '/multipickerassign',
			name: 'multipickerassign',
			component: multipickerassign,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/multipickerassign'
				},
				{
					name: 'Assign Multipicker'
				}
				],
				title: 'Assign Multipicker'
			}
		},
		{
			path: '/requestedreport',
			name: 'requestedreport',
			component: requestedreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/requestedreport'
				},
				{
					name: 'Download Report'
				}
				],
				title: 'Download Report'
			}
		},
		{
			path: '/unicommerceproduct',
			name: 'unicommerceproduct',
			component: unicommerceproduct,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/unicommerceproduct'
				},
				{
					name: 'Unicommerce Product'
				}
				],
				title: 'Unicommerce Product'
			}
		},
		{
			path: '/channelmapping',
			name: 'channelmapping',
			component: channelmapping,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/channelmapping'
				},
				{
					name: 'Channel Mapping'
				}
				],
				title: 'Channel Mapping'
			}
		},
		{
			path: '/newchannelmapping',
			name: 'newchannelmapping',
			component: newchannelmapping,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/channelmapping'
				},
				{
					name: 'New Channel Mapping'
				}
				],
				title: 'New Channel Mapping'
			}
		},
		{
			path: '/productstock',
			name: 'productstock',
			component: productstock,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/productstock'
				},
				{
					name: 'Product Stock'
				}
				],
				title: 'Product Stock'
			}
		},
		{
			path: '/multisellerorder',
			name: 'multisellerorder',
			component: multisellerorder,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/multisellerorder'
				},
				{
					name: 'Multi Seller Orders'
				}
				],
				title: 'Multi Seller Orders'
			}
		},
		{
			path: '/ordertrackingflipkart',
			name: 'ordertrackingflipkart',
			component: ordertrackingflipkart,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/ordertrackingflipkart'
				},
				{
					name: 'Order Tracking Flipkart'
				}
				],
				title: 'Order Tracking Flipkart'
			}
		},
		{
			path: '/pickPendingMoveorder',
			name: 'pickPendingMoveorder',
			component: pickPendingMoveorder,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/pickPendingMoveorder'
				},
				{
					name: 'Pick Pending Moveorder'
				}
				],
				title: 'Pick Pending Moveorder'
			}
		},
		{
			path: '/activitylist',
			name: 'activitylist',
			component: activitylist,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/activitylist'
				},
				{
					name: 'Activity List'
				}
				],
				title: 'Activity List'
			}
		},
        {
			path: '/crossdockvisibility',
			name: 'crossdockvisibility',
			component: crossdockvisibility,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/crossdockvisibility'
				},
				{
					name: 'Cross Dock Material Visibility'
				}
				],
				title: 'Cross Dock'
			}
		},
		{
			path: '/historicalreport',
			name: 'historicalreport',
			component: historicalreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/historicalreport'
				},
				{
					name: 'Historical Reports'
				}
				],
				title: 'Historical Reports'
			}
		},
		{
			path: '/reconciliationreport',
			name: 'reconciliationreport',
			component: reconciliationreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/reconciliationreport'
				},
				{
					name: 'Reconciliation Report'
				}
				],
				title: 'Reconciliation Report'
			}
		},
		{
			path: '/sla',
			name: 'sla',
			component: sla,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'SLA',
					link: '/sla'
				},
				{
					name: 'SLA management'
				}
				],
				title: 'SLA Management'
			}
		},
	
		{
			path: '/packingboxmaster',
			name: 'packingboxmaster',
			component: packingboxmaster,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/packingboxmaster'
				},
				{
					name: 'Packing Box Master'
				}
				],
				title: 'Packing Box Master'
			}
		},
		{
			path: '/xpressathon-inbound',
			name: 'Xpressathon',
			component: xpressathon,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/xpressathon-inbound'
				},
				{
					name: 'Xpressathon'
				}
				],
				title: 'Inbound - Xpressathon'
			}
		},
		{
			path: '/goodsreceiptcheck',
			name: 'Goods Receipt Check',
			component: goodsreceiptcheck,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/goodsreceiptcheck'
				},
				{
					name: 'Goods Receipt Check'
				}
				],
				title: 'Goods Receipt Check'
			}
		},
		{
			path: '/importstock',
			name: 'importstock',
			component: customstock,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/importstock'
				},
				{
					name: 'Import Stock'
				}
				],
				title: 'Import Stock'
			}
		},
		{
			path: '/stockGrn',
			name: 'stockGrn',
			component: stockGrn,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/stockGrn'
				},
				{
					name: 'Stock Audit'
				}
				],
				title: 'Stock Audit'
			}
		},
		{
			path: '/stockGrnReport',
			name: 'stockgrnreport',
			component: stockgrnreport,
			meta: {
				requiresAuth: true,
				breadcrumb: [{
					name: 'Home',
					link: '/stockGrnReport'
				},
				{
					name: 'Stock Audit Report'
				}
				],
				title: 'Stock Audit Report'
			}
		},
		{
			path: 'charts',
			name: 'Charts',
			component: Charts
		},
		{
			path: 'widgets',
			name: 'Widgets',
			component: Widgets
		},
		{
			path: 'icons',
			redirect: '/icons/font-awesome',
			name: 'Icons',
			component: {
				render(c) {
					return c('router-view')
				}
			},
			children: [{
				path: 'font-awesome',
				name: 'Font Awesome',
				component: FontAwesome
			},
			{
				path: 'simple-line-icons',
				name: 'Simple Line Icons',
				component: SimpleLineIcons
			}
			]
		}
		]
	},
	{
		path: '/login',
		name: 'login',
		component: Login
	},
	{
		path: '/invalidurll',
		name: 'invalidurll',
		component: invalidurll
	},
	{
		path: '/pages',
		redirect: '/pages/p404',
		name: 'Pages',
		component: {
			render(c) {
				return c('router-view')
			}
		},
		children: [{
			path: '404',
			name: 'Page404',
			component: Page404
		},
		{
			path: '500',
			name: 'Page500',
			component: Page500
		},
		{
			path: 'login',
			name: 'Login',
			component: Login
		},
		{
			path: 'register',
			name: 'Register',
			component: Register
		}
		]
	},
	]
});

router.beforeEach(async (to, from, next) => {
	var isLoggedIn = window.localStorage.getItem('isLoggedIn');
	var check1 = to.matched.length;
	window.document.title = to.meta.title || 'Xpressbees - Fullfillment Center'

	if (to.name == 'login') {
		if (Object.keys(to.query) == 'locale') {
			window.localStorage.setItem("locale", to.query["locale"]);
		} else {
			window.localStorage.setItem("locale", "en");
		}
	}

	if (isLoggedIn == null) {
		isLoggedIn = false;
	} else {
		isLoggedIn = true;
	}
	if (to.name == 'login' && isLoggedIn) {
		next({
			path: "/dashboard",
		});
	} else if (check1 == 0 && !isLoggedIn) {
		next({
			path: "/invalidurll",
		});
		//	window.location.href = '/INVALIDURl404NOTFOUND.html'
	} else if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
		next({
			path: "/login",
		});
	} else if (check1 > 0 && !isLoggedIn && to.name != 'login') {
		next({
			path: "/login",
		});
	} else {
		//console.log(to.meta.breadcrumb[0].link);

		if (isLoggedIn) {
			var setrole = false;
			const role = window.localStorage.getItem('role');
			var permissionEncrypt = window.localStorage.getItem('permissiondata')
			if(permissionEncrypt=='null' || permissionEncrypt==null)
			{
				localStorage.removeItem('permissiondata')
				localStorage.removeItem('userdetail')
				localStorage.removeItem('userToken')
				localStorage.removeItem('isLoggedIn')
				localStorage.removeItem('clientList')
				localStorage.removeItem('warehouseList')
				localStorage.removeItem('refreshToken')
				localStorage.removeItem('keycloakInitialized')
				
				return;
			}
			var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var permissiondata = JSON.parse(plaintext);
			var check = to.matched.length;
			permissiondata.push({"title": 'Print label', "icon": 'fa fa-home', "href": '/shippinglabel'})
			
			if (check != 0 || check > 0) {

				for (var i = 0; i < permissiondata.length; i++) {
					if (permissiondata[i].href == undefined) {
						// means sub Menu Exists
						for (var j = 0; j < permissiondata[i].child.length; j++) {
							if (permissiondata[i].child[j].child === undefined) {
								if (permissiondata[i].child[j].href == to.meta.breadcrumb[0].link) {
									setrole = true;
									break;
								}
							} else {
								if (permissiondata[i].child[j].child.length > 1) {
									//Child of Child Array
									for (var k = 0; k < permissiondata[i].child[j].child.length; k++) {
										if (permissiondata[i].child[j].child[k].href === undefined) {
											for (var l = 0; l < permissiondata[i].child[j].child[k].child.length; l++) {
												if (permissiondata[i].child[j].child[k].child[l].href == to.meta.breadcrumb[0].link) {
													setrole = true;
													break;
												}
											} // End For l
										} else {
											if (permissiondata[i].child[j].child[k].href == to.meta.breadcrumb[0].link) {
												setrole = true;
												break;
											}
										}
										if (setrole == true) {
											break;
										}
									} // END For K
								} else {
									if (permissiondata[i].child[j].child[0].href == to.meta.breadcrumb[0].link) {
										setrole = true;
										break;
									}
								}

							}
							if (setrole == true) {
								break;
							}
						} // END FOR J
						if (setrole == true) {
							break;
						}
					} else {

						if (permissiondata[i].href.toLowerCase() == to.meta.breadcrumb[0].link.toLowerCase()) {
							setrole = true;
							break;
						} else {
							console.log("Failed----->",permissiondata[i].href,"-->",to.meta.breadcrumb[0].link.toLowerCase())
							setrole = false
						}
					}


				} // END For i

				if (setrole) {
					next();
					onTheMinFunc()

					var checkbox1 = document.getElementById("checkbox1");
					if (checkbox1 != null)
						if (document.body.offsetWidth < 768) {
							if (checkbox1.checked == true) {
								checkbox1.checked = false
								$(".v-sidebar-menu").css("left", "-270px");
								$(".sidebar-fixed .main, .sidebar-fixed .app-footer").css("margin-left", "0px");
							}
						}
					} else {
						next({
							path: "/dashboard",
							query: {
								check: 1,
							}
						});
					}
			} else {
				next({
					path: "/invalidurl",
				});
				//window.location.href = '/invalidurl'
				//	return false;
			}
		} else {
			next();
		}
	}
});
async function callRefreshToken(){
	let url = apiUrl.kavachURL+'/realms/xpressbees/protocol/openid-connect/token?client_id=xbwms-ui';
	const params = new URLSearchParams();
	params.append('client_id', 'xbwms-ui');
	params.append('grant_type', 'refresh_token');
	params.append('refresh_token', localStorage.getItem('refreshToken'));



	axios({
		method: 'POST',
		'url': url,
		'data': params,
		headers: {
			'Content-Type':'application/x-www-form-urlencoded'
		}
	})
	.then(async(response) => {
		if(response.status==200)
		{
			localStorage.setItem("userToken", response.access_token);
			localStorage.setItem("refreshToken", response.refresh_token);
		}
		else
		{
			await common_helper.logout()
		}
	})
	.catch(async(httpException) => {
		if(httpException.response.status==401 || httpException.response.status==204 || httpException.response.status==400)
		{
			await common_helper.logout()
		}
		console.error('exception is:::::::::', httpException)
	});
}
setInterval(function() {
    if ( new Date().getSeconds() === 0 ) onTheMinFunc();
},10000);

function onTheMinFunc() {
	var userToken = window.localStorage.getItem('userToken')
	var myStr = userToken.replace(/"/g, '');
	var userdetailEncrypt = window.localStorage.getItem('userdetail');
	var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
	var plaintext = bytes.toString(CryptoJS.enc.Utf8);
	var userdetail = JSON.parse(plaintext);

	axios({
		method: 'POST',
		'url': apiUrl.api_url + 'checkuseractive',
		'data': {
			id: String(userdetail.userid)
		},
		headers: {
			'Authorization': 'Bearer ' + myStr,
			'Content-Type':'application/json'
		}
	})
	.then(async(response) => {
		
		if (response.data.status == false) {
			localStorage.removeItem('permissiondata')
			localStorage.removeItem('userdetail')
			localStorage.removeItem('userToken')
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem('clientList')
			localStorage.removeItem('warehouseList')
			next({
				path: "/login",
			});
			alertify.success("please log out and log in to continue");
		}
		else if(response.data.status == 401)
		{
			await callRefreshToken();
		}
	
	})
	.catch(async(httpException) => {
		if(httpException.response.status == 401)
		{
			await callRefreshToken();
		}
			console.error(httpException)
	});
}
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js